if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaItems = [];
        this.setupNavigation();
      }

      setupNavigation() {
        const prevButton = this.querySelector('.product-media-modal__nav--prev');
        const nextButton = this.querySelector('.product-media-modal__nav--next');
        const thumbnails = this.querySelectorAll('.product-media-modal__thumbnail');
        const footer = this.querySelector('.product-media-modal__footer');

        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigate(-1);
          });
          prevButton.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigate(1);
          });
          nextButton.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', (e) => {
            e.stopPropagation();
            this.goToSlide(index);
          });
          thumbnail.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        });

        // Prevent footer from closing modal
        if (footer) {
          footer.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
          if (this.hasAttribute('open')) {
            if (e.key === 'ArrowLeft') this.navigate(-1);
            if (e.key === 'ArrowRight') this.navigate(1);
            if (e.key === 'Escape') this.hide();
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]')).filter(
          item => !item.classList.contains('product-media-modal__thumbnail')
        );
        this.showActiveMedia();
      }

      showActiveMedia() {
        const clickedMediaId = this.openedBy.getAttribute('data-media-id');
        
        this.mediaItems.forEach((item, index) => {
          if (item.getAttribute('data-media-id') === clickedMediaId) {
            this.currentIndex = index;
          }
        });

        this.updateMedia();
      }

      navigate(direction) {
        this.currentIndex += direction;
        
        if (this.currentIndex < 0) {
          this.currentIndex = this.mediaItems.length - 1;
        } else if (this.currentIndex >= this.mediaItems.length) {
          this.currentIndex = 0;
        }

        this.updateMedia();
      }

      goToSlide(index) {
        this.currentIndex = index;
        this.updateMedia();
      }

      updateMedia() {
        // Update active media
        this.mediaItems.forEach((item, index) => {
          if (index === this.currentIndex) {
            item.classList.add('active');
            
            // Load deferred media
            const template = item.querySelector('template');
            const content = template ? template.content : null;
            
            if (
              item.nodeName === 'DEFERRED-MEDIA' &&
              content &&
              content.querySelector('.js-youtube')
            ) {
              item.loadContent();
            }
          } else {
            item.classList.remove('active');
          }
        });

        // Update thumbnails
        const thumbnails = this.querySelectorAll('.product-media-modal__thumbnail');
        thumbnails.forEach((thumbnail, index) => {
          if (index === this.currentIndex) {
            thumbnail.classList.add('active');
            // Scroll thumbnail into view
            thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          } else {
            thumbnail.classList.remove('active');
          }
        });

        // Update counter
        const currentSlideEl = this.querySelector('.current-slide');
        if (currentSlideEl) {
          currentSlideEl.textContent = this.currentIndex + 1;
        }
      }
    }
  );
}
